export default __webpack_public_path__ + "static/media/CS-1200.40d70082.png";